import React, { useState, useRef, useEffect } from "react"
import { Upload, X, Check, AlertCircle, Loader2, Trash2, Save, AlertTriangle } from "lucide-react"
import { Button, Badge, Input, message, Typography, useCRUDController, Row, Col, Select, Tabs, Spin } from "../../ui/ot"
import StatsCard from "../../ui/stats-card"
import { PieBasicChart } from "../../charts/views/pie_basic_chart"
import { StackedColumnChart } from "../../ui/ot"
import dayjs from 'dayjs';

const colors = ["#fb7d89", "#bad1c9", "#85b873", "#e5db9e", "#f3a46c", "#f6bb5d", "#55abb8", "#005f73", "#0a9396", "#94d2bd", "#e9d8a6", "#ee9b00", "#ca6702", "#bb3e03", "#ae2012", "#9b2226", "#f94144", "#f3722c", "#f8961e", "#f9844a", "#f9c74f", "#90be6d", "#43aa8b", "#4d908e", "#577590", "#277da1"]
const basicFilterSetting = ["time_type", "branchcode", "time", 'itemtype']

const ChartWithdrawnTrend = ({
    filterSearchParams = [...basicFilterSetting],
    propsDataParams = null,
}) => {
    const [data, setData] = useState([
    ])
    const [chartConfig, setChartConfig] = useState({
        item_number: {
            label: "淘汰量",
            color: "#bad1c9"
        }
    })
    const [searchParams, setSearchParams] = useState({
        branchcode: null,
        start_time: filterSearchParams.includes("time") ? dayjs().subtract(5,"year").startOf('year').format('YYYY-MM-DD') : null,
        end_time: filterSearchParams.includes("time") ? dayjs().endOf('year').format('YYYY-MM-DD') : null,
        time_type: "year",
        ...propsDataParams
    })
    const [loading, setLoading] = useState(false)
    const dataController = useCRUDController({ apiRoute: "/koha/report/item/withdrawn/trend" })
    const getData = () => {
        setLoading(true)
        dataController.getData({
            ...searchParams
        }).then((response) => {
            setLoading(false)
            if (response) {
                let newData = Object.values(response)
                setChartConfig((pre) => {
                    const config = {}; // 建立一個空物件
                    let firstData = newData?.find((e) => true) || {}

                    Object.keys(firstData).forEach((key, index) => {
                        if (key !== 'time') {
                            config[key] = {
                                label: key,
                                color: colors[index % colors.length],
                            };
                        }
                    });
                    return config;
                })
                setData(newData)
            }
        })
    }
    const libraryController = useCRUDController({ apiRoute: "/koha/library" })
    const itemtypeController = useCRUDController({ apiRoute: "/koha/itemtypes" })

    useEffect(() => {
        getData()
    }, [searchParams])

    useEffect(() => {
        libraryController.getData({})
        itemtypeController.getData({})
    }, [])
    return (<Row >
        <Col span={24}>
            <Row gutter={[4, 4]}>
                {filterSearchParams.includes("time_type") ? <Col>
                    <Row align={"middle"} gutter={[8, 8]}>
                        <Col>
                            <Tabs
                                activeKey={searchParams?.time_type}
                                onChange={(value) => {
                                    setSearchParams((pre) => {
                                        return {
                                            ...pre,
                                            time_type: value
                                        }
                                    })
                                }}
                                items={[
                                    {
                                        key: "year",
                                        tab: "年"
                                    },
                                    {
                                        key: "month",
                                        tab: "月"
                                    }
                                ]}
                            >

                            </Tabs>
                        </Col>
                    </Row>
                </Col> : <></>}
                {filterSearchParams.includes("time") ? <Col  >
                    <Row gutter={[4, 4]} align={"middle"}>
                        <Col>
                            <Typography.P>
                                顯示區間:
                            </Typography.P>
                        </Col>
                        <Col>
                            <Input
                                placeholder={"起"}
                                type="date"
                                value={searchParams?.start_time ? searchParams?.start_time : ""}
                                onChange={(e) => {
                                    setSearchParams((pre) => {
                                        if (dayjs(e.target.value).isBefore(dayjs(pre?.end_time, "YYYY-MM-DD"))) {
                                            return {
                                                ...pre,
                                                start_time: dayjs(e.target.value).format("YYYY-MM-DD"),
                                            }
                                        }
                                        else {
                                            return {
                                                ...pre,
                                                start_time: pre?.end_time,
                                                end_time: e.target.value,
                                            }
                                        }

                                    })
                                }}
                            />
                        </Col>
                        <Col>
                            <Typography.Title level={4}>
                                ~
                            </Typography.Title>
                        </Col>
                        <Col>
                            <Input
                                placeholder={"訖"}
                                type="date"
                                value={searchParams?.end_time ? searchParams?.end_time : ""}
                                onChange={(e) => {
                                    setSearchParams((pre) => {
                                        if ((dayjs(e.target.value)).isBefore(pre?.start_time)) {
                                            return {
                                                ...pre,
                                                start_time: e.target.value,
                                                end_time: pre?.start_time,
                                            }
                                        }
                                        else {
                                            return {
                                                ...pre,
                                                end_time: e.target.value,
                                            }
                                        }

                                    })
                                }}
                            />
                        </Col>
                        {(searchParams.start_time || searchParams.end_time) &&
                            <Col>
                                <Button
                                    type={"icon"}
                                    onClick={() => {
                                        setSearchParams((pre) => {
                                            return {
                                                ...pre,
                                                start_time: undefined,
                                                end_time: undefined
                                            }
                                        })
                                    }}>
                                    X
                                </Button>
                            </Col>
                        }
                    </Row>
                </Col> : <></>}
                {filterSearchParams.includes("branchcode") ? <Col>
                    <Row align={"middle"} gutter={[8, 8]}>
                        <Col>
                            分館篩選：
                        </Col>
                        <Col>
                            <Select
                                allowClear={true}
                                defaultValue={searchParams?.branchcode}
                                value={searchParams?.branchcode}
                                onChange={(value) => {
                                    setSearchParams((pre) => {
                                        return {
                                            ...pre,
                                            branchcode: value
                                        }
                                    })
                                }}
                                options={libraryController?.ResponseData?.map((option) => {
                                    return {
                                        label: `(${option?.branchcode})${option?.branchname}`,
                                        value: option?.branchcode,
                                    }
                                })}
                            >
                            </Select>
                        </Col>
                    </Row>
                </Col> : <></>}
                {filterSearchParams.includes("itemtype") ? <Col>
                    <Row align={"middle"} gutter={[8, 8]}>
                        <Col>
                            館藏分類篩選：
                        </Col>
                        <Col>
                            <Select
                                allowClear={true}
                                defaultValue={searchParams?.itemtype}
                                value={searchParams?.itemtype}
                                onChange={(value) => {
                                    setSearchParams((pre) => {
                                        return {
                                            ...pre,
                                            item_type: value
                                        }
                                    })
                                }}
                                options={itemtypeController?.ResponseData?.map((option) => {
                                    return {
                                        label: `(${option?.itemtype})${option?.description}`,
                                        value: option?.itemtype,
                                    }
                                })}
                            >
                            </Select>
                        </Col>
                    </Row>
                </Col> : <></>}
            </Row>
        </Col>
        {loading ? <Col span={24}>
            <Row justify="center">
                <Col>
                    <Spin />
                </Col>
            </Row>
        </Col>
            :
            <Col span={24}>
                {data.length === 0 ?
                    <Row justify="center">
                        <Col>
                            無資料 
                        </Col>
                    </Row>
                    :
                    <StackedColumnChart
                        //數值類型的key
                        chartConfig={chartConfig}
                        //data
                        chartData={data}
                        //X 軸顯示的名稱的key
                        xDataKeyArr={["time"]}
                        //Y 軸顯示的名稱得key
                        yDataKeyArr={Object.keys(chartConfig)} //幾條線
                        //要不要顯示標籤在頂部
                        showLabel={true}
                    />
                }
            </Col>}
    </Row >)
}
export { ChartWithdrawnTrend }